import { AWStageDto } from '@api/Api';

type DefineIsNextStageHasDeadlineProps = {
  stages: AWStageDto[];
  stage: AWStageDto;
};
export default function defineIsNextStageHasDeadline({
  stages,
  stage
}: DefineIsNextStageHasDeadlineProps) {
  const currentStageIndex = stages.findIndex((it) => it.id === stage.id);
  const isNextHasDeadLine = stages.find(
    (it, idx) => idx > currentStageIndex && it.deadline
  )?.deadline;

  return !!isNextHasDeadLine;
}
